import { appBus } from '..'

export function pauseBackgroundMusic() {
  appBus.commands.emit('backgroundMusic.pause')
}
